import { render, staticRenderFns } from "./CompetitionCard.vue?vue&type=template&id=20785f8e&"
import script from "./CompetitionCard.vue?vue&type=script&lang=js&"
export * from "./CompetitionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports